<template>
  <i-card color="teal" size="sm" am-table-pane>
    <div class="_display:flex _justify-content:space-between _align-items:center">
      <div class="_display:flex" am-settings>
        <div class="_position:relative _margin-right:1/2">
          <i-button
            :class="`_color:${inkline.options.colorMode === 'dark' || darkMode ? 'light' : 'dark'}`"
            size="sm"
            outline
            @click="isRowOption = !isRowOption"
          >
            Row
          </i-button>
          <i-card am-row-options v-if="isRowOption" v-click-outside="() => isRowOption = false">
            <p
              :am-row-text="inkline.options.colorMode === 'dark' || darkMode ? 'dark' : 'light'"
              class="_font-size:sm"
              @click="setRowsSize('short')"
            >
              Short
            </p>
            <p
              :am-row-text="inkline.options.colorMode === 'dark' || darkMode ? 'dark' : 'light'"
              class="_font-size:sm"
              @click="setRowsSize('medium')"
            >
              Medium
            </p>
            <p
              :am-row-text="inkline.options.colorMode === 'dark' || darkMode ? 'dark' : 'light'"
              class="_font-size:sm"
              @click="setRowsSize('tall')"
            >
              Tall
            </p>
            <p
              :am-row-text="inkline.options.colorMode === 'dark' || darkMode ? 'dark' : 'light'"
              class="_font-size:sm"
              @click="setRowsSize('extraTall')"
            >
              Extra Tall
            </p>
          </i-card>
        </div>
        <div class="_position:relative">
          <i-button
            :class="`_color:${inkline.options.colorMode === 'dark' || darkMode ? 'light' : 'dark'}`"
            size="sm"
            :outline="$route.query.filter ? false : true"
            @click="$store.state.filter.isShowFilter = !$store.state.filter.isShowFilter"
          >
            <svg
              viewBox="0 0 24 24"
              am-icon
              :style="`fill: ${inkline.options.colorMode === 'dark' || darkMode ? 'white' : 'black'}`"
              class="_margin-right:1/4"
            >
              <use xlink:href="@/assets/icons.svg#filter" x="0" y="0" width="24" height="24"></use>
            </svg>
            {{ this.$route.query.filter ? 'Filtered' : 'Filter'}}
          </i-button>
          <filter-item
            am-row-options
            v-if="$store.state.filter.isShowFilter"
            v-click-outside="() => $store.state.filter.isShowFilter = false"
          />
        </div>
      </div>
      <div>
        <i-button
          size="sm"
          @click="resetTableStyle($route.params.subtable)"
          am-add-button
        >
          Reset Table Config
        </i-button>
        <i-button
          size="sm"
          class="_margin-left:1/4"
          color="secondary"
          @click="$router.push({
            name: 'InstructionsView',
            params: {
              db: $route.params.db,
              table: $route.params.table,
              subtable: $route.params.subtable
            }
          })"
          am-add-button
        >
          Sewing instructions
        </i-button>
        <i-button
          size="sm"
          color="info"
          @click="addPart()"
          am-add-button
          class="_margin-left:1/4"
        >
          Add new record
          <i-icon name="ink-plus" class="_margin-left:1/2" />
        </i-button>
        <i-button
          v-if="haveChanges"
          size="sm"
          color="success"
          class="_margin-left:1/4"
          :disabled="saveLoading"
          @click="saveChangedParts($route.params.subtable)"
        >
          Save
          <i-icon name="ink-check" class="_margin-left:1/2" />
        </i-button>
        <i-button
          size="sm"
          :color="reprocessing ? 'danger' : 'warning'"
          class="_margin-left:1/4"
          :disabled="saveLoading"
          @click="reprocessing ? cancelReprocess() : confirmReprocessAll()"
        >
          {{ reprocessing ? `Cancel (${reprocessProgress.current}/${reprocessProgress.total})` : 'Update All' }}
        </i-button>
      </div>
    </div>
  </i-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FilterItem from './tableFilterItem'

export default {
  name: 'TheTablePane',
  components: {
    FilterItem
  },
  inject: ['inkline'],
  data: () => ({
    isRowOption: false
  }),
  computed: {
    ...mapState('parts', ['changedParts', 'saveLoading', 'changedImages', 'reprocessing', 'reprocessProgress']),
    haveChanges () {
      return Object.keys(this.changedParts).length > 0 || Object.keys(this.changedImages).length > 0
    },
    darkMode () {
      if (document.body.classList.contains('-dark')) {
        return true
      } else return false
    }
  },
  methods: {
    ...mapActions('parts', ['addData', 'saveChangedParts', 'reprocessAllParts', 'cancelReprocess']),
    ...mapActions('ui', ['resizeRows', 'resetTableStyle']),
    ...mapActions('filter', ['setFilter']),
    setRowsSize (height) {
      this.resizeRows({
        subtable: this.$route.params.subtable,
        height: height
      })
    },
    confirmReprocessAll () {
      if (window.confirm('This will re-process all parts on this page and regenerate their elements. Continue?')) {
        this.reprocessAllParts(this.$route.params.subtable)
      }
    },
    async addPart () {
      const subtable = this.$route.params.subtable
      await this.addData(subtable)
      const tableWrapper = document.querySelector('[am-table-wrapper]')
      const table = document.querySelector('[am-table]')
      tableWrapper.scrollTo({
        top: table.getBoundingClientRect().height,
        behavior: 'smooth'
      })
    }
  },
  mounted () {
    if (this.$route.query.filter) {
      this.setFilter({
        filter: JSON.parse(this.$route.query.filter),
        subtable: this.$route.params.subtable
      })
    }
  }
}
</script>

<style lang="scss">
  .card[am-table-pane] {
    width: 100%;
    position: sticky;
    left: 0;
    top: 0;
    z-index: 3;

    .button {
      ----padding-top: 0.125rem;
      ----padding-bottom: 0.125rem;
    }
    [am-settings] {
      button {
        border: none;
      }
      [am-row-options] {
        position: absolute;
        top: calc(100% + 5px);
        [am-row-text] {
          padding: 5px;
          cursor: pointer;
          text-wrap: nowrap;
          &:hover {
            background-color: var(--color--light-40);
          }
        }
        [am-row-text~='dark']:hover {
          background-color: var(--color--dark-40);
        }
      }
      .card .card-body {
        padding: 10px;
      }
    }
  }

  .-light {
    .card[am-table-pane] {
      ----background: var(--color--light-40);
      ----body--padding: 0.25rem;
      ----border-color: var(--border-color);
      ----color: var(--body--color--light);

      a, a:visited { color: var(----color); }
    }
  }

  .-dark {
    .card[am-table-pane] {
      ----background: var(--color--dark-35);
      ----body--padding: 0.25rem;
      ----border-color: var(--border-color);
      ----color: var(--body--color--dark);

      a, a:visited { color: var(----color); }
    }
  }

</style>
